import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikField } from "@air/formik-field";
import { Input } from "@air/primitive-input";
import { DIMENSION_BAR_INPUT } from "~/constants/testIDs";
const DimensionBarInputWrapper = (param)=>{
    let { children, dimensionMeasurement, dimensionUnits, onFocus } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center",
        onFocus: ()=>onFocus(true),
        onBlur: ()=>onFocus(false),
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-12 font-bold uppercase",
                children: dimensionMeasurement
            }),
            children,
            /*#__PURE__*/ _jsx("p", {
                className: "text-16 text-grey-11",
                children: dimensionUnits
            })
        ]
    });
};
export const DimensionBarInput = (param)=>{
    let { dimensionMeasurement, dimensionUnits, disabled, onChange, onFocus, ["data-testid"]: testId } = param;
    return /*#__PURE__*/ _jsx(DimensionBarInputWrapper, {
        dimensionUnits: dimensionUnits,
        dimensionMeasurement: dimensionMeasurement,
        onFocus: onFocus,
        children: /*#__PURE__*/ _jsx(FormikField, {
            id: dimensionMeasurement,
            className: "mx-1.5 w-16",
            isLabelHidden: true,
            label: dimensionMeasurement,
            name: dimensionMeasurement,
            isErrorHidden: true,
            onChange: onChange,
            component: /*#__PURE__*/ _jsx(Input, {
                size: "large",
                type: "number",
                className: "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                "data-testid": testId || DIMENSION_BAR_INPUT,
                disabled: disabled
            })
        })
    });
};
